import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { Tabs } from 'antd';
import { ContentBackground } from '@/components/content';
import { ContainerFluid, Section } from '@/components/layouts';
import RootLayout from '@/components/layouts/RootLayout';
import { ROUTES } from '@/constants';

const BASE_PATH = `${ROUTES.admin}/${ROUTES.timeTracking}`;

export default function TimeTracking() {
  const { t } = useTranslation(['menus']);
  const location = useLocation();
  const navigate = useNavigate();

  const activeKey = useMemo(() => {
    const path = location.pathname;
    if (path.includes('/approval')) return 'approval';
    if (path.includes('/reports')) return 'reports';
    return 'projects';
  }, [location.pathname]);

  const tabItems = useMemo(
    () => [
      { key: 'projects', label: t('projects', { ns: 'menus' }) },
      { key: 'approval', label: t('approval', { ns: 'menus' }) },
      { key: 'reports', label: t('reports', { ns: 'menus' }) },
    ],
    [t]
  );

  const handleTabChange = (key) => {
    if (key === 'projects') {
      navigate(BASE_PATH);
    } else {
      navigate(`${BASE_PATH}/${key}`);
    }
  };

  return (
    <RootLayout metadata={{ title: t('timeTracking', { ns: 'menus' }) }}>
      <ContentBackground source="/assets/images/bg-pattern.svg" />
      <Section>
        <ContainerFluid className="foreground-wrapper">
          <Tabs
            activeKey={activeKey}
            onChange={handleTabChange}
            items={tabItems}
            className="mb-4"
          />
          <Outlet />
        </ContainerFluid>
      </Section>
    </RootLayout>
  );
}
